export default "__VITE_ASSET__af6586e2__"